<mat-drawer #mainDrawer mode="over" style="position: fixed;height:100%; width:380px;border-radius:0 !important;z-index:10000;overflow:auto !important;" position="end" id="drawer" [(opened)]="vm.isOpen" *ngIf="vm.initialized">
	<div class="c-card">
		<div class="c-content">
			<div class="o-grid">
				<div class="o-grid__cell o-grid__cell--center-v u-no-p">
					<h2 class="c-card__title u-no-m">{{ 'How_It_Works.Title' | translate }}</h2>
				</div>
				<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--center-v u-no-p">
					<button id="closeButton" type="button" class="c-button c-button--icon c-button--tp" (click)="vm.close()">
						<i class="o-icon o-icon--x u-no-mr" aria-hidden="true"></i>
					</button>
				</div>
			</div>
		</div>
		<div class="c-content u-no-pt">
			<ul class="c-list">
				<li class="c-list__item u-ost-sm">
					<div class="o-grid">
						<div class="o-grid__cell o-grid__cell--w-fixed u-no-p">
							<i class="o-icon o-icon--user c-list__icon" aria-hidden="true"></i>
						</div>
						<div class="o-grid__cell o-grid__cell--w-fixed u-no-p">
							<p class="c-text c-text--spaced u-osr-sm">1.</p>
						</div>
						<div class="o-grid__cell u-no-p">
							<p class="c-text c-text--spaced u-no-m">{{ 'How_It_Works.Item1' | translate }}</p>
						</div>
					</div>
				</li>
				<li class="c-list__item u-ost-sm">
					<div class="o-grid">
						<div class="o-grid__cell o-grid__cell--w-fixed u-no-p">
							<i class="o-icon o-icon--clock c-list__icon" aria-hidden="true"></i>
						</div>
						<div class="o-grid__cell o-grid__cell--w-fixed u-no-p">
							<p class="c-text c-text--spaced u-osr-sm">2.</p>
						</div>
						<div class="o-grid__cell u-no-p">
							<p class="c-text c-text--spaced u-no-m">{{ 'How_It_Works.Item4' | translate }}</p>
							<ul class="c-list c-list--ul">
								<li class="c-list__item u-ost-sm">
									<p class="c-text c-text--spaced u-no-m">{{ 'How_It_Works.Item4-1' | translate }}</p>
								</li>
								<li class="c-list__item u-ost-sm">
									<p class="c-text c-text--spaced u-no-m">{{ 'How_It_Works.Item4-2' | translate }}</p>
								</li>
							</ul>
						</div>
					</div>
				</li>
				<li class="c-list__item u-ost-sm">
					<div class="o-grid">
						<div class="o-grid__cell o-grid__cell--w-fixed u-no-p">
							<i class="o-icon o-icon--video c-list__icon" aria-hidden="true"></i>
						</div>
						<div class="o-grid__cell o-grid__cell--w-fixed u-no-p">
							<p class="c-text c-text--spaced u-osr-sm">3.</p>
						</div>
						<div class="o-grid__cell u-no-p">
							<p class="c-text c-text--spaced u-no-m">{{ 'How_It_Works.Item5-1' | translate }} <a href="{{vm.urls?.avTest}}" target="_blank">{{ 'How_It_Works.Item5-2' | translate }}</a> {{ 'How_It_Works.Item5-3' | translate }}</p>
						</div>
					</div>
				</li>
				<li class="c-list__item u-ost-sm">
					<div class="o-grid">
						<div class="o-grid__cell o-grid__cell--w-fixed u-no-p">
							<i class="o-icon o-icon--check c-list__icon" aria-hidden="true"></i>
						</div>
						<div class="o-grid__cell o-grid__cell--w-fixed u-no-p">
							<p class="c-text c-text--spaced u-osr-sm">4.</p>
						</div>
						<div class="o-grid__cell u-no-p">
							<p class="c-text c-text--spaced u-no-m">{{ 'How_It_Works.Item6' | translate }}</p>
						</div>
					</div>
				</li>
				<li class="c-list__item u-ost-sm">
					<div class="o-grid">
						<div class="o-grid__cell o-grid__cell--w-fixed u-no-p">
							<i class="o-icon o-icon--home c-list__icon" aria-hidden="true"></i>
						</div>
						<div class="o-grid__cell o-grid__cell--w-fixed u-no-p">
							<p class="c-text c-text--spaced u-osr-sm">5.</p>
						</div>
						<div class="o-grid__cell u-no-p">
							<p class="c-text c-text--spaced u-no-m">{{ 'How_It_Works.Item7' | translate }}</p>
						</div>
					</div>
				</li>
				<li class="c-list__item u-ost-sm">
					<div class="o-grid">
						<div class="o-grid__cell o-grid__cell--w-fixed u-no-p">
							<i class="o-icon o-icon--envelope c-list__icon" aria-hidden="true"></i>
						</div>
						<div class="o-grid__cell o-grid__cell--w-fixed u-no-p">
							<p class="c-text c-text--spaced u-osr-sm">6.</p>
						</div>
						<div class="o-grid__cell u-no-p">
							<p class="c-text c-text--spaced u-no-m">{{ 'How_It_Works.Item8' | translate }}</p>
							<ul class="c-list c-list--ul">
								<li class="c-list__item u-ost-sm">
									<p class="c-text c-text--spaced u-no-m">{{ 'How_It_Works.Item9' | translate }}</p>
								</li>
								<li class="c-list__item u-ost-sm">
									<p class="c-text c-text--spaced u-no-m">{{ 'How_It_Works.Item10' | translate }}</p>
								</li>
							</ul>
						</div>
					</div>
				</li>
			</ul>
			<p class="c-card__subtitle u-ost-xl">{{ 'How_It_Works.Item11' | translate }}</p>
			<p class="c-text u-ost-lg">{{ 'How_It_Works.Item12' | translate }}</p>
			<p class="c-text u-ost-lg">{{ 'How_It_Works.Item13' | translate }}</p>
		</div>
	</div>
</mat-drawer>
